/** Frozen legal-document version. Do not use Date.now() on these pages. */
export const LEGAL_VERSION = '2026-09-08';
export const LEGAL_UPDATED_LABEL = 'September 8, 2026';
